import React, { useEffect, useState } from "react";
import Button from "../../fields/Button";
import { GLOBAL_VARIABLES } from "../../../../utilites/variables";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../../Store/action";
import MultiLineDoubleFieldInputs from "../../fields/MultiLineDoubleFieldInputs";
import OtherDataAdditionForm from "./OtherDataAdditionForm";
import { HandleFormData } from "../../../../utilites";

const Assets = () => {
	//
	//  ---------------------------------------
	//  Variables , States & Store States
	//  ---------------------------------------
	//
	const dispatch = useDispatch();

	const { assetsOptions } = GLOBAL_VARIABLES;

	const uploadFormData = HandleFormData({ parentIndex: 4, myIndex: 0 });

	const [{ taxPayerFormData, taxPayerForm, formInformation }] = useSelector((state) => [state.taxForms]);
	// For Text Input Field

	// For Choice Questions
	const [assetsTypes, setAssetsTypes] = useState(JSON.parse(JSON.stringify(assetsOptions)));
	// ---------------------------------------
	// HOOKS TO STORE DATA
	// ---------------------------------------

	// SAVE VALUES TO STATES
	useEffect(() => {
		if (taxPayerForm?.data?.AssetsForm) {
			if (Object.keys(taxPayerForm?.data?.AssetsForm).length === 0) return;

			const { assetsTypes } = taxPayerForm?.data?.AssetsForm;

			setAssetsTypes(assetsTypes);
		}
	}, [taxPayerForm?.data?.AssetsForm]);

	const handleAmountChange = (id, index, name) => {
		const myInputAmount = document.getElementById(id);
		let localDeduction = assetsTypes;
		console.log(myInputAmount.value, name);
		localDeduction[index][name] = myInputAmount.value;
		setAssetsTypes(JSON.parse(JSON.stringify(localDeduction)));
	};
	// ---------------------------------------
	// Functions
	// ---------------------------------------

	const handleSubmit = (e) => {
		e.preventDefault();

		let FormObj = {
			assetsTypes,
		};

		let formData = taxPayerForm;
		taxPayerForm.data.AssetsForm = FormObj;
		dispatch(allActions.taxForms.StoreFormData({ formData }));

		uploadFormData(formData);
	};

	const goBack = () => {
		// CHANGE FORM TO BACK
		let parentIndex = 4;
		let myIndex = 0;
		dispatch(allActions.taxForms.moveToBack({ parentIndex, myIndex, taxPayerFormData }));
	};

	return (
		<form className="w-100 mt-3" onSubmit={handleSubmit}>
			<MultiLineDoubleFieldInputs
				Options={assetsTypes}
				firstPlaceHolder={"Beginning of year"}
				handleChange={handleAmountChange}
				secondPlaceHolder={"End of year"}
			/>

			<OtherDataAdditionForm
				oldValues={assetsTypes}
				setState={setAssetsTypes}
				heading="Other Assets"
				BtnText="Add Assets"
				Datakeys={["question", "BeginningOfYear", "EndOfYear"]}
				DataLabels={["Description", "Beginning of year", "End of year"]}
			/>

			<div className="container-fluid content-row pb-4">
				<div className="d-flex align-items-center justify-content-center row">
					<Button
						mainClass="btn btn-info custon-button-text  w-100 text-dark"
						buttonText="Previous"
						wrapperClass={"w-25 custon-button  mt-4"}
						type="button"
						callback={() => goBack()}
					/>

					<Button
						mainClass="btn btn-primary custon-button-text   w-100"
						buttonText="Next"
						wrapperClass={"w-25 custon-button  mt-4"}
						type="submit"
						disabled={!formInformation?.lead_id}
					/>
				</div>
			</div>
		</form>
	);
};

export default Assets;
